export function removeItemsFromSources(sources, {fileIds = [], folderIds = []} = {}) {
    const fileIdSet = new Set(fileIds.map(String));
    const folderIdSet = new Set(folderIds.map(String));

    return {
        ...sources,
        files: (sources?.files || []).filter((file) => !fileIdSet.has(String(file.id))),
        folders: (sources?.folders || []).filter((folder) => !folderIdSet.has(String(folder.id))),
    };
}
